import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.*

@Composable
fun SkillsSection() {
    Section({
        id("Skills")
        style {
            padding(32.px)
        }
    }) {
        H2 { Text("Skills") }
        Ul {
            listOf("Kotlin", "Java", "Jetpack Compose", "Android SDK", "Room Database", "Retrofit", "MVVM Architecture").forEach { skill ->
                Li { Text(skill) }
            }
        }
    }
}
